export { default as PersonalizationTab } from './components/PersonalizationTab';

export { PERSONALIZATION_SETTINGS_GATE, PERSONALIZATION_TOP_SECTION, getLearnerObjectSettings } from './constants';
export type { LearnerObjectFieldId } from './constants';

export { useIsPersonalizationSettingsEnabled } from './featureFlags';
